export default "__VITE_ASSET__BICtEPo5__"